/** Normalize ArcGIS/CMS feature type strings for fuzzy matching. */
export function normalizeFeatureTypeName(value) {
  if (value == null) return '';
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

function featureTypeMatches(candidate, featureType) {
  if (!candidate || featureType == null || featureType === '') return false;
  if (candidate === featureType) return true;
  return normalizeFeatureTypeName(candidate) === normalizeFeatureTypeName(featureType);
}

function matchProjectFeature(features, featureType) {
  if (!Array.isArray(features) || !featureType) return null;

  const exact = features.find((item) => item.cmsName === featureType);
  if (exact) return exact;

  const byCmsName = features.find((item) => featureTypeMatches(item.cmsName, featureType));
  if (byCmsName) return byCmsName;

  return features.find((item) => featureTypeMatches(item.title, featureType)) || null;
}

/**
 * Resolve feature detail content for a map feature_type.
 * Prefers project-linked records (for locations), falls back to the global catalog.
 */
export function resolveProjectFeatureForType(projectFeatures, featureCatalog, featureType) {
  const projectMatch = matchProjectFeature(projectFeatures, featureType);
  const catalogMatch = matchProjectFeature(featureCatalog, featureType);

  if (projectMatch && catalogMatch) {
    return {
      ...catalogMatch,
      ...projectMatch,
      description: projectMatch.description || catalogMatch.description,
      image: projectMatch.image || catalogMatch.image,
      projectFeatureLocations: projectMatch.projectFeatureLocations || [],
    };
  }

  const match = projectMatch || catalogMatch;
  if (!match) return null;

  return {
    ...match,
    projectFeatureLocations: match.projectFeatureLocations || [],
  };
}
